module.exports = __webpack_public_path__ + "img/bert-icon-footer.68fd8c9d.png";